export default __webpack_public_path__ + "static/media/find-my-friend.5ffea4b8.svg";